import { ReactComponent as RouteIcon } from 'assets/icons/route.svg'
import ActionButton from 'components/ActionButton'
import IconWrapper from 'components/IconWrapper'
import { bodyPrimaryColor } from 'styles/styleVariables'
import type { Order } from 'types'
import useRerouteOrder from './useRerouteOrder'

type RerouteButtonProps = { order: Order; disabled?: boolean }

const RerouteButton = ({ order, disabled }: RerouteButtonProps): JSX.Element => {
  const rerouteOrder = useRerouteOrder(order)

  return (
    <ActionButton
      data-testid="Reroute"
      icon={
        <IconWrapper>
          <RouteIcon fill={bodyPrimaryColor} />
        </IconWrapper>
      }
      onClick={rerouteOrder}
      label="Reroute"
      hotKey="ar"
      hotKeyLabel="a-r"
      disabled={disabled}
    />
  )
}
export default RerouteButton
